import { render, staticRenderFns } from "./SocialSeriesStatusBar.vue?vue&type=template&id=38b23d40&"
import script from "./SocialSeriesStatusBar.vue?vue&type=script&lang=js&"
export * from "./SocialSeriesStatusBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38b23d40')) {
      api.createRecord('38b23d40', component.options)
    } else {
      api.reload('38b23d40', component.options)
    }
    module.hot.accept("./SocialSeriesStatusBar.vue?vue&type=template&id=38b23d40&", function () {
      api.rerender('38b23d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialSeriesStatusBar.vue"
export default component.exports